import React, { createContext, useState } from 'react'
import ModalCargando from '../utilsComponentes/ModalCargando';

export const ContextGloball = createContext();

function ContextGlobal({ children }) {
  const [singUp, setSingUp] = useState({});
  const [titulo, setTitulo] = useState('');
  const [ventana, setVentana] = useState('0');
  const [showMenu,setShowMenu] = useState(false);
  const [loading,setLoading] = useState(false);
  const [esReporte, setEsReporte] = useState(false);
  return (
    <ContextGloball.Provider value={{
      singUp,setSingUp,
      titulo,setTitulo,
      ventana,setVentana,
      showMenu,setShowMenu,
      loading,setLoading,
      esReporte, setEsReporte
    }}>
      {children}
      <ModalCargando show={loading} />
    </ContextGloball.Provider>
  )
}

export default ContextGlobal
